<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.score" :value="ruleScore"/>
      <rule-game :title="ruleTitle.inscreasePoint" :value="ruleInscreasePoint"/>
      <rule-game :title="ruleTitle.special" :value="ruleSpecial"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/13cards/Chinese13-Board.png';
import cardOne from '../../assets/gamerule/13cards/1.png';
import cardTwo from '../../assets/gamerule/13cards/2.png';
import ruleCardOne from '../../assets/gamerule/13cards/score/1.png';
import ruleCardTwo from '../../assets/gamerule/13cards/score/2.png';
import ruleCardThree from '../../assets/gamerule/13cards/score/3.png';
import ruleCardFour from '../../assets/gamerule/13cards/score/4.png';
import ruleCardFive from '../../assets/gamerule/13cards/score/5.png';
import ruleCardSix from '../../assets/gamerule/13cards/score/6.png';
import ruleCardSeven from '../../assets/gamerule/13cards/score/7.png';
import ruleCardEight from '../../assets/gamerule/13cards/score/8.png';
import ruleCardNine from '../../assets/gamerule/13cards/score/9.png';
import ruleCardTen from '../../assets/gamerule/13cards/score/10.png';
import inscreaseCardOne from '../../assets/gamerule/13cards/increasepoint/0.png';
import inscreaseCardTwo from '../../assets/gamerule/13cards/increasepoint/1.png';
import inscreaseCardThree from '../../assets/gamerule/13cards/increasepoint/2.png';
import inscreaseCardFour from '../../assets/gamerule/13cards/increasepoint/3.png';
import inscreaseCardFive from '../../assets/gamerule/13cards/increasepoint/4.png';
import inscreaseCardSix from '../../assets/gamerule/13cards/increasepoint/5.png';
import specialCardOne from '../../assets/gamerule/13cards/special/1.png';
import specialCardTwo from '../../assets/gamerule/13cards/special/2.png';
import specialCardThree from '../../assets/gamerule/13cards/special/3.png';
import specialCardFour from '../../assets/gamerule/13cards/special/4.png';
import specialCardFive from '../../assets/gamerule/13cards/special/5.png';

export default {
  name: 'rule_13cards',
  data() {
    return {
      ruleHeader: {
        gameName: 'Chinese Poker',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราจ่าย',
        rule: 'กติกา',
        score: 'แต้มไพ่',
        inscreasePoint: 'ไพ่ที่เพิ่มคะแนน',
        special: 'ไพ่พิเศษ',

      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1:0.97 (หากผู้เล่นลงเดิมพัน 100 และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท)',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: 'ใช้ไพ่ 1 สำรับจำนวน 52 ใบสามารถเล่นได้สูงสุด 4 คน และน้อยสุด 2 คน โดยจะต้องแจกไพ่ให้ผู้เล่นแต่ละคนไปเรื่อยๆ จนครบคนละ 13 ใบ หลังจากนั้นให้ผู้เล่นแต่ละคนดูไพ่ของตนเองในมือ และทำการจัดไพ่ที่มีอยู่ในมือโดยเกมส์ไพ่สามกองนั้น ผู้เล่นจะต้องทำการจัดชุดไพ่ออกเป็น 3 ชุดและต้องแน่ใจว่าเราเรียงลำดับถูก ถ้าใครยังไม่แน่ใจหรือยังไม่รู้ว่าต้องเรียงไพ่ ใหญ่หรือเล็กยังไง โดยจะเรียงจากเล็กที่สุดในเกมส์ไปหาใหญ่สุด',
          class: 'ml-2',
        },
        {
          type: 'text',
          text: 'ไพ่สามกองมีหลักในการจำง่ายๆ เริ่มจากเกมส์ไพ่สามกองจะมีรูปแบบการจัดไพ่คือ 3-5-5 นั่นก็คือ แถวบนจะวางไพ่ได้ 3 ใบและต้องมีแต้มน้อยที่สุด แถวกลางวางไพ่ได้ 5 ใบและต้องมีแต้มมากกว่าแถวบนและน้อยกว่าแถวล่าง สุดท้ายแถวล่างต้องมีแต้มมากกว่าแถวกลางและแถวบน',
          class: 'ml-2 mt-4',
        },
        {
          type: 'imageNoborder',
          image: cardOne,
        // class: 'w-100'
        },

        {
          type: 'imageTextNoborder',
          image: cardTwo,
          class: '',
          text: 'โดยจะแบบเป็นแถวบน แถวกลาง และแถวล่าง โดยให้เพื่อนๆจัดไพ่จากแถวล่างสุดก่อนเพราะว่าแถวล่างสุดจะต้องเป็นไพ่ที่มีแต้มมากที่สุด ส่วนมากจะนิยมเป็นไพ่โฟร์การ์ด ไพ่เห่าหรือเรียง ต่อมาแถวที่สองหรือแถวกลางให้มีแต้มน้อยกว่าแถวล่างสุดแต่ต้องมีแต้มมากกว่าแถวบน เช่นถ้าแถวล่างสุดเป็นไพ่โฟร์การ์ด แถวกลางจะต้องเป็นโฟร์การ์ดหรือเห่า ถ้าเอาสเตรทฟรัชมาเรียง จะกดยืนยันไม่ได้ ถ้าหากหมดเวลาระบบจะทำการจัดให้โดยอัตโนมัติส่วนแถวบนสุดนิยมจัดให้ได้ไพ่ 1 คู่ หรือดีที่สุดคือไพ่ตอง แต่ถ้าในตานั้นเราได้ไพ่ไม่ดีเลยจริงๆล่ะก็ วางไพ่สูงไปได้เลย',

        },
      ],
      ruleScore: [
        {
          type: 'text',
          text: 'เรียงแต้มไพ่ใหญ่ที่สุดลงไปหาแต้มเล็กที่สุด โดยเรียงจากรอยัลฟลัช > สเตรทฟลัช > โฟร์การ์ด  > ฟลูเฮ้าส์  > ไพ่สี  > ไพ่เรียง > ไพ่ตอง > 2คู่ > 1คู่ > ไพ่สูง',
          class: 'ml-2',
        },
        {
          type: 'text',
          text: '1. รอยัลฟลัช',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardOne,
          class: 'w-50',
          text: 'คือ ไพ่ที่เรียงกัน 5 ใบเป็นดอกเดียวกันและต้องสีเดียวกันเป็นไพ่ 10 , J , Q , K , A เท่านั้น',
        },
        {
          type: 'text',
          text: '2. สเตรทฟลัช',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardTwo,
          class: 'w-50',
          text: 'คือ ไพ่ที่เรียงกันสีเดียวกันและเรียงกัน 5 ใบเป็นดอกเดียวกัน และไม่ใช่ 10 , J , Q , K , A ',
        },
        {
          type: 'text',
          text: '3. โฟร์การ์ด',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardThree,
          class: 'w-50',
          text: 'คือ ไพ่ที่มีแต้มเหมือนกัน 4 ใบ ( อีก1 ใบเป็นอะไรก็ได้ )',
        },
        {
          type: 'text',
          text: '4. ฟลูเฮ้าส์',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardFour,
          class: 'w-50',
          text: 'คือ ไพ่ 1 ชุดมีแต้มเหมือนกัน 3 ใบ อีก 1 ชุด มีแต้มเหมือนกัน 2 ใบ',
        },
        {
          type: 'text',
          text: '5. ไพ่สี',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardFive,
          class: 'w-50',
          text: 'คือ ไพ่ที่มีสีหรือดอกเดียวกัน 5 ใบ ไม่จำเป็นต้องมีไพ่เรียงกัน',
        },
        {
          type: 'text',
          text: '6. ไพ่เรียง',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardSix,
          class: 'w-50',
          text: 'คือ ไพ่ที่มีแต้มเรียงกันดอกใดก็ได้ ( ไม่จำเป็นต้องสีเดียวกัน )',
        },
        {
          type: 'text',
          text: '7. ไพ่ตอง',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardSeven,
          class: 'w-50',
          text: 'คือ ไพ่ที่มีแต้มเหมือนกัน 3 ใบ',
        },
        {
          type: 'text',
          text: '8. 2 คู่',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardEight,
          class: 'w-50',
          text: 'คือ ไพ่ที่มีแต้มเหมือนกัน 2 จำนวน  2 ชุด',
        },
        {
          type: 'text',
          text: '9. 1 คู่',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardNine,
          class: 'w-50',
          text: 'คือ ไพ่ที่มีแต้มเหมือนกัน 2 จำนวน แค่ 1 ชุด',
        },
        {
          type: 'text',
          text: '10. ไพ่สูง',
          class: 'ml-4',
        },
        {
          type: 'imageText',
          image: ruleCardTen,
          class: 'w-50',
          text: 'คือ ไพ่ที่ไม่สามารถจับคู่หรือจัดวางเข้ากลุ่มไพ่ได้ ส่วนมากจะจัดวางไว้แถวบนสุด',
        },
      ],
      ruleInscreasePoint: [
        {
          type: 'text',
          text: '1. ไพ่คู่',
          class: 'ml-4 mt-4',
        },
        {
          type: 'image',
          image: inscreaseCardOne,
          class: 'w-40',
        },
        {
          type: 'text',
          text: '2. ไพ่ตอง',
          class: 'ml-4',
        },
        {
          type: 'image',
          image: inscreaseCardTwo,
          class: 'w-40',
        },
        {
          type: 'text',
          text: '3. ไพ่เห่า',
          class: 'ml-4',
        },
        {
          type: 'image',
          image: inscreaseCardThree,
          class: 'w-60',
        },
        {
          type: 'text',
          text: '4. ไพ่โฟร์การ์ด',
          class: 'ml-4',
        },
        {
          type: 'image',
          image: inscreaseCardFour,
          class: 'w-60',
        },
        {
          type: 'text',
          text: '5. ไพ่สเตรทฟลัช',
          class: 'ml-4',
        },
        {
          type: 'image',
          image: inscreaseCardFive,
          class: 'w-60',
        },
        {
          type: 'text',
          text: '6. ไพ่รอยัลฟลัช',
          class: 'ml-4',
        },
        {
          type: 'image',
          image: inscreaseCardSix,
          class: 'w-60',
        },
        {
          type: 'text',
          text: 'ยิงปืน',
          class: 'ml-4',
        },
        {
          type: 'textSub',
          text: 'เมื่อชนะผู้เล่นคนอื่นทั้ง 3 ชุด ได้เพิ่ม x2 ต่อคน',
          class: 'ml-4',
        },
        {
          type: 'text',
          text: 'โฮมรัน',
          class: 'ml-4',
        },
        {
          type: 'textSub',
          text: 'คือชนะทุกคนทุกชุด ตั้งแต่ 2 คนขึ้นไป',
          class: 'ml-4',
        },
        {
          type: 'textSub',
          text: 'ชนะ 2 คน ได้เพิ่ม x3',
          class: 'ml-4',
        },
        {
          type: 'textSub',
          text: 'ชนะ 3 คน ได้เพิ่ม x4',
          class: 'ml-4',
        },
      ],
      ruleSpecial: [
        {
          type: 'text',
          text: 'ได้ +6 ทุกคน 6คู่กึ่ง , ไพ่สี 3 ชุด , สเตรท 3 ชุด ไม่ทะลุ',
          class: 'ml-2',
        },
        {
          type: 'text',
          text: '1. มังกรสเตรทฟลัช',
          class: 'ml-4 mt-3',
        },
        {
          type: 'imageTextRow',
          image: specialCardOne,
          class: 'card-cp13',
          text: 'เรียงจากแต้มน้อยที่สุดไปมากที่สุด โดยแต้มน้อยที่สุดต้องอยู่ชุดบน เช่น  2 3 4 ชุดกลาง 5 6 7 8 9 และชุดล่างสุดต้องมีแต้มเยอะที่สุด 10 J Q K A  ต้องดอกเดียวกันและต้องเรียงกัน ทั้งหมด +26 ทุกคน',
        },
        {
          type: 'text',
          text: '2. มังกร',
          class: 'ml-4',
        },
        {
          type: 'imageTextRow',
          image: specialCardTwo,
          class: 'w-50',
          text: 'เรียงจากแต้มน้อยที่สุด ไปแต้มมากที่สุด โดยแต้มน้อยที่สุดต้องอยู่ชุดบน เช่น  2 3 4 ชุดกลาง 5 6 7 8 9 และชุดล่างสุดต้องมีแต้มเยอะที่สุด 10 J Q K A  ไม่จำเป็นต้องดอกเดียวกันแต่ต้องเรียงแต้มกัน ทั้งหมด +13 ทุกคน',
        },
        {
          type: 'text',
          text: '3. 6 คู่ครึ่ง',
          class: 'ml-4',
        },
        {
          type: 'imageTextRow',
          image: specialCardThree,
          class: 'w-50',
          text: 'คือไพ่ที่ เรียงกันแล้วได้ 6 คู่ ส่วนอีก 1 ใบ เป็นอะไรก็ได้ +6 ทุกคน',
        },
        {
          type: 'text',
          text: '4. ไพ่สีสามชุด',
          class: 'ml-4',
        },
        {
          type: 'imageTextRow',
          image: specialCardFour,
          class: 'w-50',
          text: 'เรียงจาก ดอกที่ใหญ่ที่สุดต้องอยู่ชุดล่างสุด ชุดกลางต้องดอกที่เล็กกว่าชุดล่างเช่นชุดล่างเป็น โพธิ์แดง ชุดกลางต้องเป็นดอกจิก  ส่วนชุดบนจะเป็นอะไรก็ได้+6 ทุกคน',
        },
        {
          type: 'text',
          text: '5. สเตรท 3 ชุด',
          class: 'ml-4',
        },
        {
          type: 'imageTextRow',
          image: specialCardFive,
          class: 'w-50',
          text: 'เรียงจากชุดล่างสุดต้องเรียงแต้มเยอะที่สุด เช่น 9 10 J Q K ชุดกลางต้องเรียงแต้มน้อยกว่าชุดล่างและมากกว่าชุดบน เช่น 6 7 8 9 10 ส่วนชุดบนเรียงแต้มที่น้อยที่สุด  2 3 4+6 ทุกคน',
        },
      ],

    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
